import 'react-native-reanimated';
import 'react-native-gesture-handler';
import React, {useEffect} from 'react';
import {AppRegistry} from 'react-native';
import App from './src/app';
import {name as appName} from './app.json';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {store} from './src/redux/store';

const ConnectedApp = () => {
  useEffect(() => {
    // Handle resizing and ensure full height
    const handleResize = () => {
      // Update viewport height variable
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);

      // Set explicit height
      document.body.style.height = `${window.innerHeight}px`;

      // Apply to root element
      const rootElement = document.getElementById('root');
      if (rootElement) {
        rootElement.style.height = `${window.innerHeight}px`;
      }
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    // Initial settings
    handleResize();

    // Re-check after a short delay to ensure everything is rendered
    setTimeout(handleResize, 100);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

// Register the app for native platforms
AppRegistry.registerComponent(appName, () => ConnectedApp);

// Web entrypoint using createRoot (React 18+ / 19+)
const rootTag = document.getElementById('root');

if (rootTag) {
  const root = createRoot(rootTag);
  root.render(<ConnectedApp />);
} else {
  console.error('❌ Root element not found in index.html');
}
